<template>
  <div class="container">
    <div v-if="loading" class="loading">
      <van-loading size="24px" color="#1989fa" vertical>加载中...</van-loading>
    </div>
    <div v-else class="pdf-list">
      <div
        class="item"
        v-for="item in pdfList"
        :key="item.id"
        @click="preview(item)"
      >
        <div class="preview">
          <van-image height="120" fit="contain" :src="item.img_url || require('@/assets/pdf.png')" />
        </div>
        <div class="info">
          <div class="name">{{ item.res_name }}</div>
        </div>
        <van-icon class="arrow" name="arrow" />
      </div>
    </div>
  </div>
</template>

<script>
import { resList } from "@/api/video";
export default {
  name: "ResList",
  data() {
    return {
      loading: true,
      pdfList: [],
    };
  },
  mounted() {
    const params = this.$route.params;
    this.pId = params.pId;
    document.title = params.title || "资源列表";
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      resList({
        pId: this.pId,
      })
        .then((res) => {
          if (res.code) {
            this.pdfList = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    preview(item) {
      console.log('预览PDF:', item);
      if (!item.res_url) {
        this.$toast('PDF链接无效');
        return;
      }
      this.$router.push({
        name: "pdfPreview",
        params: {
          title: item.res_name || 'PDF预览',
          url: encodeURIComponent(item.res_url),
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  height: 100%;
  background-color: #f5f5f5;
  
  .loading {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .pdf-list {
    min-height: 100vh;
    padding: 12px;

    .item {
      display: flex;
      align-items: center;
      background-color: #fff;
      padding: 12px;
      border-radius: 8px;
      margin-bottom: 12px;

      .preview {
        width: 80px;
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #f8f8f8;
        border-radius: 4px;
        flex-shrink: 0;
      }
      
      .info {
        flex: 1;
        margin-left: 12px;
        overflow: hidden;
        
        .name {
          font-size: 15px;
          color: #333;
          font-weight: bold;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        
        .desc {
          font-size: 13px;
          color: #999;
          margin-top: 6px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      
      .arrow {
        color: #ccc;
        font-size: 16px;
        margin-left: 8px;
      }
    }
  }
}
</style>
